// Glow Cyber Pong / Air Hockey Client
import { sounds } from '../sound.js';

export class CyberPongClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.tableWidth = 800;
    this.tableHeight = 500;
    this.ball = { x: 400, y: 250, radius: 10 };
    this.p1Y = 250;
    this.p2Y = 250;
    this.score1 = 0;
    this.score2 = 0;

    this.render();
    this.setupSocketEvents();
    this.setupControls();
  }

  render() {
    this.container.innerHTML = `
      <div class="pong-wrapper">
        <div class="pong-header">
          <h2>🏓 GLOW CYBER PONG</h2>
          <div class="pong-scoreboard">
            <span class="score red" id="pong-s1">0</span>
            <span class="score-divider">:</span>
            <span class="score blue" id="pong-s2">0</span>
          </div>
        </div>

        <div class="pong-canvas-box">
          <canvas id="pong-canvas" width="800" height="500"></canvas>
        </div>
      </div>
    `;

    this.canvas = document.getElementById('pong-canvas');
    this.ctx = this.canvas.getContext('2d');
  }

  setupControls() {
    const movePaddle = (e) => {
      const rect = this.canvas.getBoundingClientRect();
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const canvasY = (clientY - rect.top) * (this.canvas.height / rect.height);
      this.socket.emit('pong_paddle', { y: canvasY });
    };

    this.canvas.addEventListener('mousemove', movePaddle);
    this.canvas.addEventListener('touchmove', movePaddle, { passive: false });
  }

  setupSocketEvents() {
    this.socket.on('pong_started', (data) => {
      this.tableWidth = data.tableWidth;
      this.tableHeight = data.tableHeight;
    });

    this.socket.on('pong_state', (data) => {
      this.ball = data.ball;
      this.p1Y = data.p1Y;
      this.p2Y = data.p2Y;
      this.draw();
    });

    this.socket.on('pong_score', (data) => {
      sounds.playChime();
      this.score1 = data.score1;
      this.score2 = data.score2;
      const s1 = document.getElementById('pong-s1');
      const s2 = document.getElementById('pong-s2');
      if (s1) s1.innerText = this.score1;
      if (s2) s2.innerText = this.score2;
    });

    this.socket.on('pong_gameOver', (data) => {
      sounds.playVictory();
      alert(`🏆 PONG CHAMPION: ${data.winner?.name || 'Player'}!`);
    });
  }

  draw() {
    if (!this.ctx) return;
    this.ctx.fillStyle = '#090d16';
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

    // Center divider
    this.ctx.strokeStyle = 'rgba(56, 189, 248, 0.2)';
    this.ctx.setLineDash([8, 8]);
    this.ctx.lineWidth = 2;
    this.ctx.beginPath();
    this.ctx.moveTo(this.canvas.width / 2, 0);
    this.ctx.lineTo(this.canvas.width / 2, this.canvas.height);
    this.ctx.stroke();
    this.ctx.setLineDash([]);

    // Left Paddle (Red / Orange)
    this.ctx.fillStyle = '#ef4444';
    this.ctx.shadowColor = '#ef4444';
    this.ctx.shadowBlur = 14;
    this.ctx.fillRect(20, this.p1Y - 45, 12, 90);

    // Right Paddle (Blue / Cyan)
    this.ctx.fillStyle = '#38bdf8';
    this.ctx.shadowColor = '#38bdf8';
    this.ctx.shadowBlur = 14;
    this.ctx.fillRect(this.canvas.width - 32, this.p2Y - 45, 12, 90);

    // Ball
    this.ctx.fillStyle = '#facc15';
    this.ctx.shadowColor = '#facc15';
    this.ctx.shadowBlur = 16;
    this.ctx.beginPath();
    this.ctx.arc(this.ball.x, this.ball.y, this.ball.radius, 0, Math.PI * 2);
    this.ctx.fill();
    this.ctx.shadowBlur = 0;
  }

  destroy() {
    this.socket.off('pong_started');
    this.socket.off('pong_state');
    this.socket.off('pong_score');
    this.socket.off('pong_gameOver');
  }
}
